import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { find, last } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

function GoogleSecurityCommandCenterMappingForm(props, ref) {
    const [projects, setProjects] = useState(() => {
      if (props.record) {
        const { organization_id, organization_name } = props.record;
        return [{id: organization_id, name: organization_name}]
      }
      return [];
    });

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      const newProject = projects.map(project => {
        return {
          ...project,
          id: last(project.id.split('/'))
        }
      })
      setProjects(newProject);
    }).catch(() => {
      message.error('Problem fetching organization');
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { organization_id } = config;
    const organization_name = find(projects, (obj) => obj.id === organization_id)?.name;

    return ({
      organization_id,
      organization_name,
    });
  }

  const extraFields = useMemo(() => ([
    {
      name: 'organization_id',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Organization',
      options: projects.map(option => {
        const { label = option.name, value = option.id } = option;
        return { label, value }
      }),
      required: true,
      props: {
        autoFocus: true
      }
    },
  ]), [projects]);

  return (
    <GenericMappingForm
      {...props}
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
    />
  )
}

export default forwardRef(GoogleSecurityCommandCenterMappingForm)
